"use client";

import React, { useEffect, useState } from "react";
import HeaderSection from "./HeaderSection";
import styles from "@/styles/carousel.module.css";
import useWindowDimensions from "@/hooks/useWindowDimensions";
import dynamic from "next/dynamic";
import ShowAllButton from "./ShowAllButton";
import HorizontalVillaList from "../ReactWindow/HorizontalVillaList";
import VillaCard from "@/components/Card/VillaCard";

const SwiperComponent = dynamic(() => import("./SwiperComponent"), {
  ssr: false,
});

const HomeFeaturedVillas = ({ title, vitrins, url }) => {
  const width = useWindowDimensions();
  const [isCarouselEnabled, setIsCarouselEnabled] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsCarouselEnabled(width >= 640);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  return (
    <div className="overflow-hidden lg:pb-[100px] md:pb-14 sm:pb-7 pb-5">
      <div className="container px-4">
        <HeaderSection title={title} url={url} />
        <div className={`${styles.FeaturedVillas} relative sm:mb-0 mb-4 `}>
          {isCarouselEnabled ? (
            <SwiperComponent villas={vitrins} />
          ) : (
            <HorizontalVillaList vitrins={vitrins}>
              <VillaCard />
            </HorizontalVillaList>
          )}
        </div>
        <ShowAllButton title={title} url={url} styles="inline-flex sm:hidden" />
      </div>
    </div>
  );
};

export default HomeFeaturedVillas;
